import { render } from "./BaseLoader.vue?vue&type=template&id=41837996"
import script from "./BaseLoader.vue?vue&type=script&lang=js"
export * from "./BaseLoader.vue?vue&type=script&lang=js"

import "./BaseLoader.vue?vue&type=style&index=0&id=41837996&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__